export default "__VITE_ASSET__CFTavSe8__"